export default {
  functional: true,
  props: {
    area: {
      type: String,
      required: true
    },
    local: {
      type: String,
      required: true
    },
    no: {
      type: String,
      required: true
    }
  },
  render(h, context) {
    if(context.props.area && context.props.local && context.props.no) {
      const numAll = context.props.area + context.props.local + context.props.no
      const numArea = h('span', context.props.area)
      const numLocal = h('span', context.props.local)
      const numNo = h('span', context.props.no)
  
      const parentBlockData = {
        class: {
          "telnumber": true
        }
      }
      const linkData = {
        attrs: {
          "href": 'tel:' + numAll
        }
      }

      const link = h('a', linkData, [ numArea, numLocal, numNo ])
      return h('p', parentBlockData, [link])
    } else {
      return h('p', null, '-')
    }
  }
}
